// 公共请求钩子
import { publicOpen } from "@/api/jhk/public";
export const useJdCrm = (that)=>{
  publicOpen().then((res) => {
    if (res.message) {
      that.jdCrm.endTime = res.message;
    }
  });
}